import React from 'react';
import CSS from 'csstype';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';

export const PageHeader = ({
  children,
  styles
}: {
  children: JSX.Element;
  styles?: CSS.Properties;
}) => {
  return (
    <Box py={2} sx={styles}>
      <Typography variant='h4'>{children}</Typography>
    </Box>
  );
};

export const PageHeaderLeftIcon = ({
  children,
  icon: Icon
}: {
  children: JSX.Element;
  icon: JSX.Element;
}) => {
  return (
    <Box
      py={2}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        position: 'relative'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: '3rem',
          top: '3rem',
          width: '4rem',
          height: '4rem'
        }}
      >
        {Icon}
      </Box>
      <Typography variant='h4'>{children}</Typography>
    </Box>
  );
};

export const PageHeaderWithFilter = ({
  title,
  children
}: {
  title: string;
  children: JSX.Element;
}) => {
  return (
    <Box py={2} sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography variant='h4'>{title}</Typography>
      {children}
    </Box>
  );
};
